module.exports = __webpack_public_path__ + "media/sweepstakes_and_promotions/degreed_back-4fdd4eb3.gif";